<style lang="stylus">
    .rightclickmenu-aimenulist
        .ft-menu
            cursor pointer
            .ft-menutext
                font-size 14px
    .list-sub-list,
    .tone-sub-list,
    .language-sub-list
        position absolute
        padding 6px
        background-color var(--bg-color-tertiary)
        border 0.5px solid var(--border-color-box-4)
        box-shadow $box-shadow
        border-radius 8px
        overflow hidden

    .list-sub-list
        width 212px
        max-height 360px
        cursor default
        overflow auto
        p
            padding 0 0 12px 4px
        .list-expandgroup
            display flex
            justify-content flex-start
            align-items center
            flex-wrap wrap
            padding-bottom 12px
        .list-expanditem
            height 48px
            padding 4px
            border-radius $ft-boxradius
            cursor pointer
            .item-icon
                width 40px
                height 40px
            &:not(.active):hover
                background $ft-hover
            &.active
                background $ft-active
</style>

<template>
    <div class="rightclickmenu-aimenulist">
        <AIFloatMenuPictureAnalysis v-if="!isAIFlowChild && !isSelectedSingleText" :fromType="'rightClickMenu'" />
        <div v-if="!isAIFlowChild && !activeAiSymbol" class="ft-aigray-text" :class="{ 'ft-h-divided': !isSelectedSingleText && !internal }">
            <p>{{ $t("AIText") }}</p>
        </div>
        <MenuList
            @mouseover.stop
            :menuList="AiContentList"
            @handleClicks="handleClicks(...arguments)"
            @handleMouseenter="handleMouseenter(...arguments)"
        ></MenuList>
        <!-- sub menus -->
        <div
            v-show="showMenu == 'textList' || mouseOverTarget == 'listMenu'"
            ref="listMenu"
            class="list-sub-list"
            @mousedown.stop
            @mouseenter="mouseOverTarget = 'listMenu'"
            @mouseleave="mouseOverTarget = null"
        >
            <p>{{ $t("listType1") }}</p>
            <div class="list-expandgroup">
                <div
                    class="list-expanditem"
                    :class="{ active: item - 1 == listStyleActiveID }"
                    v-for="item in 4"
                    :key="item"
                    @click="clickListStyle(item - 1)"
                >
                    <iconSymbol class="item-icon" :name="`liststyle${item}${isDarkTheme() ? '-dark' : ''}`"></iconSymbol>
                </div>
            </div>
            <p>{{ $t("listType2") }}</p>
            <div class="list-expandgroup">
                <div
                    class="list-expanditem"
                    :class="{ active: item - 1 == listStyleActiveID }"
                    v-for="item in [5, 6, 7, 8, 9, 10, 11, 12, 13]"
                    :key="item"
                    @click="clickListStyle(item - 1)"
                >
                    <iconSymbol class="item-icon" :name="`liststyle${item}${isDarkTheme() ? '-dark' : ''}`"></iconSymbol>
                </div>
            </div>
            <p>{{ $t("listType3") }}</p>
            <div class="list-expandgroup">
                <div
                    class="list-expanditem"
                    :class="{ active: item - 1 == listStyleActiveID }"
                    v-for="item in [14, 15, 16, 17, 18, 19]"
                    :key="item"
                    @click="clickListStyle(item - 1)"
                >
                    <iconSymbol class="item-icon" :name="`liststyle${item}${isDarkTheme() ? '-dark' : ''}`"></iconSymbol>
                </div>
            </div>
        </div>
        <MenuList
            v-show="showMenu == 'textTone' || mouseOverTarget == 'toneMenu'"
            :menuList="toneList"
            ref="toneMenu"
            @handleClicks="handleToneClicks(...arguments)"
            @mouseenter.native="mouseOverTarget = 'toneMenu'"
            @mouseleave.native="mouseOverTarget = null"
        />
        <MenuList
            v-show="showMenu == 'textTranslate' || mouseOverTarget == 'langMenu'"
            :menuList="languageList"
            ref="langMenu"
            @handleClicks="handleLangClicks(...arguments)"
            @mouseenter.native="mouseOverTarget = 'langMenu'"
            @mouseleave.native="mouseOverTarget = null"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";
    import AiSocket from "@/app/mixin/aiSocket";
    import AIFloatMenuPictureAnalysis from "@/app/components/FloatTool/AIFloatMenuPictureAnalysis.vue";
    import { aidrawLibs } from "@/app/utils/constant";
    import { blobToBase64 } from "@/public/utils/tool.js";

    @Component({
        components: {
            MenuList,
            AIFloatMenuPictureAnalysis,
        },
    })
    export default class AiMenuList extends AiSocket {
        @Prop({ default: false })
        isAIFlowChild;

        showMenu = "";
        mouseOverTarget = null;

        get isText() {
            return this.$store.state.shape.type === "TextBlock";
        }
        get isMultiSel() {
            return this.$store.state.shape.isMultiSel;
        }
        // 单选文本时，不显示图片分析
        get isSelectedSingleText() {
            return this.isText && !this.isMultiSel;
        }
        get activeText() {
            return this.$store.state.shape.activeText;
        }
        get listStyleActiveID() {
            return this.$store.state.shape.fontFmt.bulletStyle;
        }
        get isMMShape() {
            return this.$store.state.shape.isMMShape;
        }
        get AiContentList() {
            let list = [
                {
                    key: "aiSymbol",
                    label: this.$t("aiSymbol"),
                    img: "ai-mindmap-arrange",
                    isRender: this.activeAiSymbol && window.EDCONFIG.AI.DRAW_ENABLE,
                },
                {
                    key: "textExpend",
                    label: this.$t("textExpend"),
                    img: "ai-text-expend",
                    isRender: !this.isMMShape,
                },
                {
                    key: "nodeExpend",
                    label: this.$t("nodeExpend"),
                    img: "ai-node-expend",
                    isRender: this.isMMShape,
                },
                {
                    key: "textRetouch",
                    label: this.$t("textRetouch"),
                    img: "ai-text-retouch",
                },
                {
                    key: "summarize",
                    label: this.$t("textSummary"),
                    img: "ai-text-summary",
                },
                {
                    key: "textList",
                    label: this.$t("textList"),
                    img: "ai-text-list",
                    expand: true,
                },
                {
                    key: "textElongate",
                    label: this.$t("textElongate"),
                    img: "ai-text-elongate",
                },
                {
                    key: "textShorten",
                    label: this.$t("textShorten"),
                    img: "ai-text-shorten",
                },
                {
                    key: "textTone",
                    label: this.$t("textTone"),
                    img: "ai-text-tone",
                    expand: true,
                },
                {
                    key: "textTranslate",
                    label: this.$t("textTranslate"),
                    img: "ai-text-translate",
                    expand: true,
                },
                {
                    key: "more",
                    label: this.$t("more"),
                    img: "ai-more",
                },
                // { key: "mindmapArrange", label: this.$t("mindmapArrange"), img: 'ai-mindmap-arrange', disabled: !this.isMMShape },
            ];

            list = list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true));
            return { list };
        }
        get toneList() {
            return {
                container: "tone-sub-list",
                list: [
                    { key: "toneType1", label: this.$t("toneType1") },
                    { key: "toneType2", label: this.$t("toneType2") },
                    { key: "toneType3", label: this.$t("toneType3") },
                    { key: "toneType4", label: this.$t("toneType4") },
                    { key: "toneType5", label: this.$t("toneType5") },
                ],
            };
        }
        get languageList() {
            return {
                container: "language-sub-list",
                list: [
                    { key: "lang_en", label: this.$t("lang_en") },
                    { key: "lang_cn", label: this.$t("lang_cn") },
                    { key: "lang_jp", label: this.$t("lang_jp") },
                    { key: "lang_kr", label: this.$t("lang_kr") },
                    { key: "lang_es", label: this.$t("lang_es") },
                    { key: "lang_fr", label: this.$t("lang_fr") },
                    { key: "lang_de", label: this.$t("lang_de") },
                    { key: "lang_it", label: this.$t("lang_it") },
                ],
            };
        }
        get canAddToOneBoundary() {
            return this.$store.state.mindmaster.canAddToOneBoundary;
        }
        markdownData() {
            if (!window["_view"]) return "";
            return window["_view"].getShapeMarkdownData();
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            this.closeContext();
            if (this.agreePlus || this.readLocal()) {
            } else {
                this.showAgreement();
                if (key === "aiSymbol") {
                    this.$store.commit("setDialogState", {
                        type: "aiDrawBtn",
                        data: "aiMenuListToAidraw",
                    });
                }
                return;
            }

            // prettier-ignore2
            let clickEvents = new Map([
                [
                    "textExpend",
                    () => {
                        this.aiPromise("continue").then(() => {
                            let _view = window["_view"],
                                page = _view._activePage;
                            let textList = this.resultText.split("\n");
                            textList.unshift(this.inputText);
                            _view.generateTextTemplate(page, textList);
                        });
                    },
                ],
                [
                    "nodeExpend",
                    () => {
                        this.aiPromise("mindmap").then(() => {
                            let list = this.resultText.split("\n");
                            window["_view"].generateSubTopic(list);
                        });
                    },
                ],
                // ["textList", () => {}],
                [
                    "textRetouch",
                    () => {
                        this.aiPromise("polish").then(() => {
                            window["_view"].replaceShapeText(this.resultText);
                        });
                    },
                ],
                [
                    "summarize",
                    () => {
                        if (this.canAddToOneBoundary) {
                            const prompt = this.markdownData();
                            window["_view"].AICreateSummary();
                            this.aiPromise("mindmap-summary", { prompt }).then(() => {
                                window["_view"].replacePlainTextNoAction(this.resultText);
                            });
                        } else {
                            this.aiPromise("summarize").then(() => {
                                window["_view"].replaceShapeText(this.resultText);
                            });
                        }
                    },
                ],
                [
                    "textElongate",
                    () => {
                        this.aiPromise("lengthen").then(() => {
                            window["_view"].replaceShapeText(this.resultText);
                        });
                    },
                ],
                [
                    "textShorten",
                    () => {
                        this.aiPromise("shorten").then(() => {
                            window["_view"].replaceShapeText(this.resultText);
                        });
                    },
                ],
                [
                    "more",
                    () => {
                        this.aiTextMore();
                    },
                ],
                // ["textTone", () => {}],
                // ["textTranslate", () => {}],
                // todo👇
                ["mindmapArrange", () => {}],
                [
                    "aiSymbol",
                    () => {
                        this.toAidraw();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        aiTextMore() {
            this.$bus.$emit("showAIPanel", true);
            this.$bus.$emit("aiTextMore");
            this.sensors.track("openAI", {
                Catalogues: "AI",
                open_way: "from_floating_bar",
            });
        }
        handleToneClicks(...args) {
            if (this.agreePlus || this.readLocal()) {
            } else {
                this.showAgreement();
                return;
            }
            let key = args[0],
                event = args[1];
            this.aiPromise("changeTone", { key_word1: Number(key.slice(-1)) }).then(() => {
                window["_view"].replaceShapeText(this.resultText);
            });
            this.closeContext();
        }
        handleLangClicks(...args) {
            if (this.agreePlus || this.readLocal()) {
            } else {
                this.showAgreement();
                return;
            }
            let key = args[0],
                event = args[1];
            this.aiPromise("translate", { lang: key.slice(-2) }).then(() => {
                window["_view"].replaceShapeText(this.resultText);
            });
            this.closeContext();
        }
        handleMouseenter(...args) {
            let key = args[0],
                event = args[1];
            if (["textList", "textTone", "textTranslate"].includes(key)) {
                this.showMenu = key;
                let initPosition = (ref) => {
                    this.$nextTick(() => {
                        let parentEle = <HTMLElement>event.target;
                        ref.style.left = parentEle.offsetWidth + 15 + "px";
                        ref.style.top = parentEle.offsetTop + "px";
                    });
                };
                let mouseEvents = new Map([
                    [
                        "textList",
                        () => {
                            let ref = this.$refs.listMenu;
                            initPosition(ref);
                        },
                    ],
                    [
                        "textTone",
                        () => {
                            let ref = (this.$refs.toneMenu as any).$el;
                            initPosition(ref);
                        },
                    ],
                    [
                        "textTranslate",
                        () => {
                            let ref = (this.$refs.langMenu as any).$el;
                            initPosition(ref);
                        },
                    ],
                ]);
                const mEvent = mouseEvents.get(key);
                mEvent && mEvent();
            } else {
                this.showMenu = "";
            }
        }
        clickListStyle(index) {
            if (this.agreePlus || this.readLocal()) {
            } else {
                this.showAgreement();
                return;
            }
            this.aiPromise("sort").then(() => {
                window["_view"].replaceShapeText(this.resultText, true);
                window["_view"].editStyle("bullet", index);
            });
            // todo：埋点
            // this.trackFontComment("listStyle");
        }
        closeContext() {
            this.$store.commit("closeContext");
        }
        // ai3 协议
        get userInfo() {
            return this.$store.state.userInfo || this.$store.state.user.userInfo;
        }
        agree = false;
        get agreePlus() {
            return this.agree || this.noLoginEditor;
        }
        readLocal() {
            let str = localStorage.getItem("ai3") || null;
            if (str) {
                let ai3Obj = JSON.parse(str);
                let list = ai3Obj.agreement || [];
                let exit = false;
                for (let i = 0; i < list.length; i++) {
                    if (this.userInfo.user_id == list[i].user_id) {
                        exit = true;
                        this.agree = list[i].data;
                        break;
                    }
                }
                !exit && (this.agree = false);
            } else {
                this.agree = false;
            }
            return this.agree;
        }
        showAgreement() {
            this.$store.commit("setDialogState", {
                type: "aiDrawBtn",
                data: "",
            });
            this.$bus.$emit("showAIPanel", true);
            this.$nextTick(() => {
                this.$bus.$emit("showAgreement", true);
            });
        }
        get noLoginEditor() {
            return this.$store.state.user.noLoginEditor;
        }
        aiPromise(...args) {
            if (this.noLoginEditor) {
                return this.generatingNologin(...args);
            } else {
                return this.generating(...args);
            }
        }

        get activeAiSymbol() {
            return aidrawLibs.includes(this.$store.state.shape.fromLibId);
        }
        async toAidraw() {
            const libId = this.$store.state.shape.fromLibId;
            const shapeName = window["_view"]._activeShape._nameU;
            let list = this.$store.state.library.publicLibraryData;
            let lib = list.find((item) => item.id == libId);
            if (!lib) {
                lib = await this.$bus.$asyncEmit("loadLibraryByTableId", { tableId: libId });
            }
            let shape = lib && lib.data.find((item) => item.name == shapeName);
            if (lib && shape && shape.blob) {
                const str = `${lib[this.lang] || lib["en"]}, ${shape[this.lang + "_name"] || shape["en_name"]}`;
                blobToBase64(shape.blob).then((base64) => {
                    this.$store.commit("setDialogState", {
                        type: "dialogType",
                        data: "AIDraw",
                    });
                    this.$store.commit("setDialogState", {
                        type: "showDialog",
                        data: true,
                    });
                    this.$nextTick(() => {
                        this.$bus.$emit("setAidrawOption", {
                            menu: 1,
                            style: 0,
                            image: base64,
                            text: str,
                        });
                    });
                    this.sensors.track("openAiDrawingWindow", {
                        Catalogues: "AiDrawing",
                        open_way: "generateSimilarSymbols",
                        similar_library_name: lib["en"],
                        similar_symbol_name: shape["en_name"],
                        search_symbol_content: "unknown",
                    });
                });
            }
        }
        created() {
            !this.noLoginEditor && this.initAiSocket();
        }
        mounted() {
            this.$bus.$on("aiMenuListToAidraw", () => {
                this.toAidraw();
            });
        }
        beforeDestroy() {
            let ts: any = this;
            ts.$bus.$off("aiMenuListToAidraw");
        }
    }
</script>

<i18n>
{
    "zh": {
        "AIText": "文本分析",
        "textExpend": "文字续写",
        "nodeExpend": "继续扩展思维导图",
        "textList": "文本分点",
        "textRetouch": "润色文本",
        "textSummary": "智能总结",
        "textElongate": "让这段话变长",
        "textShorten": "让这段话变短",
        "textTone": "改变语气",
        "textTranslate": "翻译",
        "mindmapArrange": "整理思维导图",
        "more": "自由提问",
        "listType1": "形状符号",
        "listType2": "数字符号",
        "listType3": "字母符号",
        "toneType1": "专业的",
        "toneType2": "随性的",
        "toneType3": "直率的",
        "toneType4": "自信的",
        "toneType5": "友好的",
        "lang_en": "英语",
        "lang_cn": "中文",
        "lang_jp": "日语",
        "lang_kr": "韩语",
        "lang_es": "西班牙语",
        "lang_fr": "法语",
        "lang_de": "德语",
        "lang_it": "意大利语",
        "aiSymbol": "生成同款符号"
    },
    "en": {
        "AIText": "Text Analysis",
        "textExpend": "Continuous Text",
        "nodeExpend": "Continue to Expand the Mind Map",
        "textList": "Text Break",
        "textRetouch": "Polish Text",
        "textSummary": "Smart Summary",
        "textElongate": "Make this passage longer",
        "textShorten": "Make this passage shorter",
        "textTone": "Change Tone",
        "textTranslate": "Translate",
        "mindmapArrange": "整理思维导图",
        "more": "Ask Me Anything",
        "listType1": "Bullets",
        "listType2": "Numbering",
        "listType3": "Numbering with alphabet",
        "toneType1": "Professional",
        "toneType2": "Informal",
        "toneType3": "Direct",
        "toneType4": "Confident",
        "toneType5": "Friendly",
        "lang_en": "English",
        "lang_cn": "中文",
        "lang_jp": "日本语",
        "lang_kr": "한국인",
        "lang_es": "Español",
        "lang_fr": "Francais",
        "lang_de": "Deutsch",
        "lang_it": "Italiano",
        "aiSymbol": "Generate similar symbols"
    },
    "de": {
        "AIText": "Textanalyse",
        "textExpend": "Fließtext",
        "nodeExpend": "Mindmap weiterhin erweitern",
        "textList": "Textumbruch",
        "textRetouch": "Text verbessern",
        "textSummary": "Zusammenfassung",
        "textElongate": "Diese Passage verlängern",
        "textShorten": "Diese Passage kürzen",
        "textTone": "Tonfall ändern",
        "textTranslate": "Übersetzen",
        "mindmapArrange": "整理思维导图",
        "more": "Weitere KI-Funktionen entdecken",
        "listType1": "Aufzählungspunkte",
        "listType2": "Nummerierung",
        "listType3": "Alphabetische Nummerierung",
        "toneType1": "Formell",
        "toneType2": "Informell",
        "toneType3": "Direkt",
        "toneType4": "Selbstbewusst",
        "toneType5": "Freundlich",
        "lang_en": "English",
        "lang_cn": "中文",
        "lang_jp": "日本语",
        "lang_kr": "한국인",
        "lang_es": "Español",
        "lang_fr": "Francais",
        "lang_de": "Deutsch",
        "lang_it": "Italiano",
        "aiSymbol": "Ähnliche Symbole erzeugen"
    },
    "es": {
        "AIText": "Análisis de texto",
        "textExpend": "Texto continuo",
        "nodeExpend": "Continúe para ampliar el mapa mental",
        "textList": "Salto de texto",
        "textRetouch": "Mejorar texto",
        "textSummary": "Resumen",
        "textElongate": "Alargar este pasaje",
        "textShorten": "Acortar este pasaje",
        "textTone": "Cambiar tono",
        "textTranslate": "Traducción",
        "mindmapArrange": "整理思维导图",
        "more": "Descubrir más funciones de IA",
        "listType1": "Viñetas",
        "listType2": "Numeración",
        "listType3": "Numeración con letras",
        "toneType1": "Profesional",
        "toneType2": "Informal",
        "toneType3": "Directo",
        "toneType4": "Seguro",
        "toneType5": "Amable",
        "lang_en": "English",
        "lang_cn": "中文",
        "lang_jp": "日本语",
        "lang_kr": "한국인",
        "lang_es": "Español",
        "lang_fr": "Francais",
        "lang_de": "Deutsch",
        "lang_it": "Italiano",
        "aiSymbol": "Generar símbolos similares"
    },
    "fr": {
        "AIText": "Analyse de texte",
        "textExpend": "Texte continu",
        "nodeExpend": "Continuer pour développer la carte mentale",
        "textList": "Saut de texte",
        "textRetouch": "Lisser le texte",
        "textSummary": "Résumé",
        "textElongate": "Allonger ce passage",
        "textShorten": "Raccourcir ce passage",
        "textTone": "Changer le ton",
        "textTranslate": "Traduire",
        "mindmapArrange": "整理思维导图",
        "more": "Découvrir plus de fonctionnalités IA",
        "listType1": "Puces",
        "listType2": "Numérotation",
        "listType3": "Numérotation alphabétique",
        "toneType1": "Professionnel",
        "toneType2": "Informel",
        "toneType3": "Direct",
        "toneType4": "Confiant",
        "toneType5": "Amical",
        "lang_en": "English",
        "lang_cn": "中文",
        "lang_jp": "日本语",
        "lang_kr": "한국인",
        "lang_es": "Español",
        "lang_fr": "Francais",
        "lang_de": "Deutsch",
        "lang_it": "Italiano",
        "aiSymbol": "Générer des symboles similaires"
    },
    "it": {
        "AIText": "Analisi testo",
        "textExpend": "Testo continuo",
        "nodeExpend": "Continua per espandere la mappa mentale",
        "textList": "Interruzione di testo",
        "textRetouch": "Testo polacco",
        "textSummary": "Riepilogo",
        "textElongate": "Imposta come passaggio più lungo",
        "textShorten": "Imposta come passaggi più corto",
        "textTone": "Cambia tono",
        "textTranslate": "Traduci",
        "mindmapArrange": "整理思维导图",
        "more": "Scopri altre funzioni AI",
        "listType1": "Elenchi puntati",
        "listType2": "Numerato",
        "listType3": "Numerato con alfabeto",
        "toneType1": "Professionale",
        "toneType2": "Informale",
        "toneType3": "Diretto",
        "toneType4": "Confidenziale",
        "toneType5": "Amichevole",
        "lang_en": "English",
        "lang_cn": "中文",
        "lang_jp": "日本语",
        "lang_kr": "한국인",
        "lang_es": "Español",
        "lang_fr": "Francais",
        "lang_de": "Deutsch",
        "lang_it": "Italiano",
        "aiSymbol": "Genera simboli simili"
    },
    "jp": {
        "AIText": "テキスト分析",
        "textExpend": "連続テキスト",
        "nodeExpend": "マインドマップの展開に進む",
        "textList": "テキストの区切り",
        "textRetouch": "テキストを推敲",
        "textSummary": "要約",
        "textElongate": "この部分を長く",
        "textShorten": "この部分を短く",
        "textTone": "トーンを変更",
        "textTranslate": "翻訳",
        "mindmapArrange": "整理思维导图",
        "more": "AI機能の詳細を表示",
        "listType1": "箇条書き",
        "listType2": "段落番号",
        "listType3": "アルファベットの段落番号",
        "toneType1": "プロらしく",
        "toneType2": "くだけた感じ",
        "toneType3": "単刀直入に",
        "toneType4": "自信を持って",
        "toneType5": "フレンドリーに",
        "lang_en": "English",
        "lang_cn": "中文",
        "lang_jp": "日本语",
        "lang_kr": "한국인",
        "lang_es": "Español",
        "lang_fr": "Francais",
        "lang_de": "Deutsch",
        "lang_it": "Italiano",
        "aiSymbol": "同様の記号を生成"
    },
    "kr": {
        "AIText": "텍스트 분석",
        "textExpend": "연속 텍스트",
        "nodeExpend": "마인드 맵을 계속 확장합니다",
        "textList": "텍스트 나누기",
        "textRetouch": "텍스트 다듬기",
        "textElongate": "이 구절을 더 길게 만들어 주세요",
        "textShorten": "이 구절을 더 짧게 만들어 주세요",
        "textTone": "톤 변경",
        "textTranslate": "번역하기",
        "mindmapArrange": "整理思维导图",
        "more": "더 많은 AI 기능 살펴보기",
        "listType1": "글머리 기호",
        "listType2": "번호",
        "listType3": "알파벳 번호",
        "toneType1": "전문적인 톤",
        "toneType2": "일상적인 톤",
        "toneType3": "직접적인 톤",
        "toneType4": "자신감 넘치는 톤",
        "toneType5": "다정한 톤",
        "lang_en": "English",
        "lang_cn": "中文",
        "lang_jp": "日本语",
        "lang_kr": "한국인",
        "lang_es": "Español",
        "lang_fr": "Francais",
        "lang_de": "Deutsch",
        "lang_it": "Italiano",
        "aiSymbol": "生成同款符号"
    },
    "pt": {
        "AIText": "Análise de texto",
        "textExpend": "Texto contínuo",
        "nodeExpend": "Continue a expandir o mapa mental",
        "textList": "Quebra de texto",
        "textRetouch": "Texto polonês",
        "textSummary": "Resumo",
        "textElongate": "Deixar essa passagem maior",
        "textShorten": "Deixar essa passagem menor",
        "textTone": "Mudar tom",
        "textTranslate": "Traduzir",
        "mindmapArrange": "整理思维导图",
        "more": "Descubra mais recursos de IA",
        "listType1": "Ordenação por pontos",
        "listType2": "Ordenação numérica",
        "listType3": "Ordenação alfabética",
        "toneType1": "Profissional",
        "toneType2": "Informal",
        "toneType3": "Direto",
        "toneType4": "Confiante",
        "toneType5": "Amigável",
        "lang_en": "English",
        "lang_cn": "中文",
        "lang_jp": "日本语",
        "lang_kr": "한국인",
        "lang_es": "Español",
        "lang_fr": "Francais",
        "lang_de": "Deutsch",
        "lang_it": "Italiano",
        "aiSymbol": "Gerar símbolos semelhantes"
    },
    "tw": {
        "AIText": "文字分析",
        "textExpend": "續寫文字",
        "nodeExpend": "繼續展開心智圖",
        "textList": "文字換行",
        "textRetouch": "文字潤色",
        "textSummary": "摘要",
        "textElongate": "加長此段落",
        "textShorten": "縮短此段落",
        "textTone": "改變語氣",
        "textTranslate": "翻譯",
        "mindmapArrange": "整理思维导图",
        "more": "探索更多 AI 功能",
        "listType1": "項目符號",
        "listType2": "編號",
        "listType3": "字母編號",
        "toneType1": "專業",
        "toneType2": "隨性",
        "toneType3": "直接",
        "toneType4": "自信",
        "toneType5": "友善",
        "lang_en": "English",
        "lang_cn": "中文",
        "lang_jp": "日本语",
        "lang_kr": "한국인",
        "lang_es": "Español",
        "lang_fr": "Francais",
        "lang_de": "Deutsch",
        "lang_it": "Italiano"
    }
}
</i18n>
